import axios from 'axios';
import stopsData from '../data/stops.json';
import ZTM_API_BASE from './ztmApi';

// Podstawowy URL do API ZTM Gdańsk (zastąp właściwym adresem)
const API_BASE_URL = 'https://ckan.multimediagdansk.pl/dataset';

// Funkcja pobierająca listę przystanków
export const fetchStops = async () => {
  // Zwracamy dane lokalne natychmiast
  // Symulujemy asynchroniczność dla zachowania kompatybilności API
  return Promise.resolve(stopsData);
};
// Funkcja pobierająca rozkład jazdy dla wybranego przystanku
export const fetchDepartures = async (stopId) => {
  try {
    const response = await axios.get(`${ZTM_API_BASE}/departures?stopId=${stopId}`);
    console.log('Odpowiedź API dla odjazdów:', response.data);

    if (response.data) {
      if (Array.isArray(response.data)) {
        return response.data;
      } else if (response.data.departures && Array.isArray(response.data.departures)) { // Dodaj sprawdzenie Array.isArray
        return response.data.departures;
      } else {
        const possibleDepartures = Object.values(response.data).find(val => Array.isArray(val));
        // Jeśli possibleDepartures to null/undefined, || [] zapewni zwrot pustej tablicy
        return possibleDepartures || [];
      }
    } else {
      // response.data jest falsy (np. null, undefined)
      return [];
    }
    // --- Nie powinno się tu dostać, ale dla pewności ---
    // return []; // Można rozważyć, ale logika powyżej powinna wystarczyć
  } catch (error) {
    console.error('Błąd podczas pobierania rozkładu jazdy dla stopId', stopId, ':', error);
    // Zamiast rzucać błąd, który może nie być złapany poprawnie i zatrzymać aplikację,
    // lepiej zwrócić pustą tablicę, a błąd zalogować. Komponent wyświetli brak danych.
    return [];
    // throw error; // Rzucanie błędu jest OK, jeśli masz globalną obsługę błędów lub łapiesz go w komponencie
  }
};

/**
 * Pobiera aktualne pozycje GPS pojazdów komunikacji miejskiej w Gdańsku
 * @returns {Promise<Object>} Obiekt zawierający dane o pozycjach pojazdów
 */
export async function getVehiclePositions() {
  try {
    const response = await fetch(`${ZTM_API_BASE}/gpsPositions?v=2`);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Błąd podczas pobierania pozycji pojazdów:', error);
    throw error;
  }
}

/**
 * Filtruje pojazdy według linii
 * @param {Array} vehicles - tablica pojazdów
 * @param {String|Number} lineNumber - numer linii do filtrowania
 * @returns {Array} Przefiltrowana tablica pojazdów
 */
export function filterVehiclesByLine(vehicles, lineNumber) {
  if (!vehicles || !Array.isArray(vehicles)) return [];

  return vehicles.filter(vehicle =>
    vehicle.routeShortName === lineNumber.toString()
  );
}

/**
 * Konwertuje dane pojazdów do formatu GeoJSON do wyświetlenia na mapie
 * @param {Array} vehicles - tablica pojazdów
 * @returns {Object} Obiekt GeoJSON z punktami reprezentującymi pojazdy
 */
export function vehiclesToGeoJSON(vehicles) {
  if (!vehicles || !Array.isArray(vehicles)) return { type: "FeatureCollection", features: [] };

  const features = vehicles.map(vehicle => {
    return {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [vehicle.lon, vehicle.lat]
      },
      properties: {
        id: vehicle.vehicleId,
        line: vehicle.routeShortName,
        headsign: vehicle.headsign,
        speed: vehicle.speed,
        delay: vehicle.delay,
        direction: vehicle.direction,
        vehicleCode: vehicle.vehicleCode,
        generated: vehicle.generated,
        tripId: vehicle.tripId,
        routeId: vehicle.routeId,
        type: parseInt(vehicle.routeShortName) <= 99 ? "tram" : "bus" // Zakładamy, że numery do 99 to tramwaje
      }
    };
  });

  return {
    type: "FeatureCollection",
    features: features
  };
}
